import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  ButtonProps,
  Text,
} from "@chakra-ui/react";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { ButtonOrder } from "shared/components/button/ButtonOrder";
import { ConfirmationDialogProps } from "shared/components/modal/confirm/ConfirmationDialog";

export interface SimpleConfirmationDialogProps {
  title: string;
  subtitle?: string;
  description: string;
  confirmButtonProps?: ButtonProps;
}

export type SimpleConfirmationDialog = React.FC<
  ConfirmationDialogProps<boolean, SimpleConfirmationDialogProps>
>;

// eslint-disable-next-line no-redeclare
export const SimpleConfirmationDialog = ({
  extraProps: { title, subtitle, description, confirmButtonProps },
  alertProps,
  onSuccess,
  onCancel,
}: ConfirmationDialogProps<boolean, SimpleConfirmationDialogProps>) => {
  const { t } = useTranslation(["common"]);

  const cancelRef = useRef(null);

  return (
    <AlertDialog {...alertProps} leastDestructiveRef={cancelRef}>
      <AlertDialogOverlay />
      <AlertDialogContent>
        <AlertDialogHeader>{title}</AlertDialogHeader>
        <AlertDialogCloseButton onClick={() => onCancel()} />
        <AlertDialogBody>
          {subtitle && (
            <Text textStyle="overline" marginBottom={4}>
              {subtitle}
            </Text>
          )}
          <Text>{description}</Text>
        </AlertDialogBody>
        <AlertDialogFooter gap={2}>
          <ButtonOrder
            dismiss={
              <Button
                ref={cancelRef}
                onClick={() => onCancel()}
                colorScheme="secondary"
              >
                {t("common:cancel")}
              </Button>
            }
            confirm={
              <Button
                {...confirmButtonProps}
                onClick={() => {
                  onSuccess(true);
                }}
              >
                {t("common:confirm")}
              </Button>
            }
          />
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
